/** The backend's code for a create refused because the same job (body shop, RO, VIN) is still open (CAR-4021). */
export const VEHICLE_IN_PROGRESS_CODE = 'QUOTE_ALREADY_EXISTS'

/**
 * The refusal a 409 QUOTE_ALREADY_EXISTS carries: the backend's message and the open record
 * (existing_quote: reference_number, stage, repair_order_num, …; null when the backend could not name it).
 * Null for any other error.
 */
export const vehicleInProgressFrom = (error) => {
  const data = error?.response?.data
  if (error?.response?.status !== 409 || data?.code !== VEHICLE_IN_PROGRESS_CODE) return null
  return { message: data.message || '', existing: data.existing_quote || null }
}
